<template>
  <div>
    <v-snackbar
      v-model="toast_active"
      class="toast-v2"
      :class="toast_style"
      :multi-line="toast_multi_line"
      :timeout="toast_timeout"
    >
      <svg-element
        v-if="toast_style === 'success'"
        icon="check"
        size="20"
      />
      <svg-element
        v-else-if="toast_style === 'warning' || toast_style === 'error'"
        icon="disclaimer"
        size="20"
      />
      <span class="nds-text-p-big-bold">
        {{ toast_text }}
      </span>

      <svg-element
        class="close-btn"
        icon="close"
        size="10"
        @click="toast_active = false"
      />
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import SvgElement from '@/components/elements/SvgElement.vue';

export default {
  name: 'ToastV2Element',
  components: {
    SvgElement,
  },
  data: () => ({
    snackbar: false,
  }),
  computed: {
    ...mapGetters({
      store_toast_active: 'toast_v2/toastActive',
      toast_multi_line: 'toast_v2/toastMultiLine',
      toast_style: 'toast_v2/toastStyle',
      toast_text: 'toast_v2/toastText',
      toast_timeout: 'toast_v2/toastTimeout',
    }),
    toast_active: {
      get() {
        return this.store_toast_active;
      },
      set(value) {
        this.set_toast_active(value);
      },
    },
  },
  methods: {
    ...mapMutations({
      set_toast_active: 'toast_v2/set_toast_active',
    }),
  },
};
</script>

<style lang="scss">
@import '@/constants/variables.module.scss';

.toast-v2 {
  z-index: map-get($zindex, toast) !important;

  .v-snackbar__wrapper {
    border: 1px solid;
    border-radius: 20px;
    bottom: 64px;
    min-width: auto;
    right: 0;
  }

  .v-snackbar__content {
    padding: 12px;
    white-space: pre-line;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  .close-btn {
    cursor: pointer;
  }

  &.success {
    .v-snackbar__wrapper {
      border-color: $salem;
      background-color: $snowy-mint;
      color: $salem;
      span {
        color: $salem;
      }
      svg {
        // when sucess, <svg> height is 20px but <use> height is 18px
        // and also it's not centered vertically(pb of viewBox I think)
        // But I avoid to change svg directly because I don't know side effect
        //(That icon is used in many places)
        // That's why I add this transform to fix it manually
        transform: translateY(1px);

        --color: #{$salem};
      }
    }
  }

  &.warning {
    .v-snackbar__wrapper {
      border-color: $yellow-orange;
      background-color: $peach-cream;
      color: $yellow-orange;
      span {
        color: $yellow-orange;
      }
      svg {
        --color: #{$yellow-orange};
      }
    }
  }

  &.error {
    .v-snackbar__wrapper {
      background-color: $pippin;
      border-color: $tomato;
      color: $tomato;
      span {
        color: $tomato;
      }
      svg {
        --color: #{$tomato};
      }
    }
  }
}
</style>
